import React, {useState, useEffect, useContext} from "react";
import logo from "../../assets/logo.png";
import {Outlet, Link} from "react-router-dom";
import DropDown from "../Util/DropDown";
import axios from "../Api";
import {useLocation} from "react-router-dom";

import AuthContext from "../context/AuthContext";

const Navbar = props => {
	// Inside your component
	const location = useLocation();
	const isHomePage = location.pathname === "/x";

	const s1 = "bg-transparent drop-shadow-lg mx-3 px-7 py-2 rounded-md text-base font-medium hover:drop-shadow-xl hover:px-10 dark:hover:bg-midnight dark:hover:drop-shadow-dark-lg";
	const [theme, setTheme] = useState(0);
	const {getLoggedIn} = useContext(AuthContext);
	const doc = document.documentElement.classList;
	useEffect(e => {
		let t = localStorage.getItem("theme");
		if (!t) {
			localStorage.setItem("theme", 0);
		}
		t = localStorage.getItem("theme");
		setTheme(t);
		if (t == 1) {
			doc.add("dark");
		}
	}, []);
	return (
		<>
			<nav className={`p-3 ${isHomePage ? "bg-transparent fixed" : "bg-white-900 sticky"}  w-full top-0 z-50 dark:bg-gray-bg`}>
				<div className="flex items-center justify-between">
					<Link to="/">
						<div className="flex items-center justify-between">
							<img className="h-14 w-auto ml-6" src={logo} draggable={false} alt="Logo" />
							<div className="text-2xl font-bold ml-2 text-blood">Sanjeevani</div>
						</div>
					</Link>
					<div className="flex items-center justify-center">
						<>
							{/**	<DropDown title="Our Organization" children={["Home", "About PulseConnect", "Contact Us"]} links={["/", "/about", "/contactUs"]}></DropDown>
							 */}{" "}
							{props.logIn ? (
								<>
									<Link to={`/${props.user}/profile`} className={s1}>
										<i className="fa-solid fa-user"></i>
									</Link>
									<Link
										to="/"
										onClick={async () => {
											await axios.get("/auth/logout", {withCredentials: true}).then(r => {});
											await getLoggedIn();
										}}
										className={s1}>
										Log Out
									</Link>
								</>
							) : (
								<>
									<DropDown title="Looking for Blood" children={["Patient Login/Register", "Blood Bank Directory"]} links={["/register/patient", "/bloodDirect"]}></DropDown>
									<DropDown
										title="Want to Donate Blood"
										children={["Donor Login/Register", "Blood Donation Events", "Understanding Blood Donation"]}
										links={["/register/donor", "/bloodCamps", "/aboutBloodDonation"]}></DropDown>
									<DropDown title="Access Blood Bank" children={["Blood Bank Login", "Add Your Bloodbank"]} links={["/login/bank", "/register/bank"]}></DropDown>
								</>
							)}
						</>
					</div>
				</div>
			</nav>
			<Outlet />
		</>
	);
};

export default Navbar;
